import { Clickable, FormikField, P, theme } from '@ahmdigital/ui';
import styled from 'styled-components';

export const { colors, media } = theme;

export const ContentWrapper = styled.div`
  @media (min-width: ${media.md}) {
    max-width: 25rem;
  }
`;

export const MaxTravellerCountP = styled(P)`
  color: ${colors.redDark};
`;

export const StyledCheckbox = styled(FormikField)`
  & > label {
    & > input {
      accent-color: ${colors.purple};
    }
  }
`;

export const StyledClickable = styled(Clickable)`
  color: ${colors.redDark};
  font-weight: bold;
`;

export const Disclaimer = styled(P)`
  color: ${colors.grey50};
`;
